import { ChartColumnIncreasing, ChartLine, Merge, MessageSquare, MessageSquareOff, Split } from 'lucide-react';
import React from 'react';
import { Icon, Label, Popup } from 'semantic-ui-react';
import { ChartSign, ChartSignValue, SeriesType, SeriesTypeValue } from '../../../../types';

type Props = {
    label: string;
    chartSign: ChartSignValue;
    seriesType: SeriesTypeValue;
    annotationsEnabled: boolean;
    separateAxis?: boolean;
    onToggleSelection: () => void;
    onToggleSign: () => void;
    onToggleChartType: () => void;
    onToggleAnnotation: () => void;
    onToggleSeparateAxis?: () => void;
};

const FieldRowBase = React.memo(function FieldRowBase({
    label,
    chartSign,
    seriesType,
    annotationsEnabled,
    separateAxis,
    onToggleSelection,
    onToggleSign,
    onToggleChartType,
    onToggleAnnotation,
    onToggleSeparateAxis,
}: Props) {
    const isSelected = chartSign !== ChartSign.OFF;
    const signColor = chartSign === ChartSign.POSITIVE ? 'green' : 'red';
    const signIcon = chartSign === ChartSign.POSITIVE ? 'plus' : 'minus';

    return (
        <tr onClick={onToggleSelection} className="cursorPointer">
            <td>{isSelected && <Icon size="tiny" name="checkmark" />}</td>
            <td
                className="cursorPointer"
                onClick={(e) => {
                    e.stopPropagation();
                    onToggleSign();
                }}
            >
                {isSelected && (
                    <Popup
                        trigger={<Icon color={signColor} size="tiny" name={signIcon} />}
                        content={<>{chartSign === ChartSign.POSITIVE ? 'Flip to negative' : 'Flip to positive'}</>}
                    />
                )}
            </td>
            <td
                className="cursorPointer"
                onClick={(e) => {
                    e.stopPropagation();
                    onToggleChartType();
                }}
            >
                {isSelected && (
                    <Popup
                        trigger={
                            seriesType === SeriesType.BARS ? (
                                <ChartColumnIncreasing size={16} strokeWidth={1} />
                            ) : (
                                <ChartLine size={16} strokeWidth={1} />
                            )
                        }
                        content={<>{seriesType === SeriesType.BARS ? 'Switch to line' : 'Switch to bars'}</>}
                    />
                )}
            </td>
            <td
                className="cursorPointer"
                onClick={(e) => {
                    e.stopPropagation();
                    onToggleAnnotation();
                }}
            >
                {isSelected && (
                    <Popup
                        trigger={
                            annotationsEnabled ? (
                                <MessageSquare size={17} strokeWidth={1} />
                            ) : (
                                <MessageSquareOff size={17} strokeWidth={1} />
                            )
                        }
                        content={<>{annotationsEnabled ? 'Disable annotations' : 'Enable annotations'}</>}
                    />
                )}
            </td>
            {onToggleSeparateAxis && (
                <td
                    className="cursorPointer"
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleSeparateAxis();
                    }}
                >
                    {isSelected && (
                        <Popup
                            trigger={
                                separateAxis ? <Merge size={17} strokeWidth={1} /> : <Split size={17} strokeWidth={1} />
                            }
                            content={<>{separateAxis ? 'Merge to shared axis' : 'Split to separate axis'}</>}
                        />
                    )}
                </td>
            )}
            <td>{label}</td>
        </tr>
    );
});

export default FieldRowBase;
